import { Row } from './row';

export class Matrix {
  public name = 'testName';
  public rows: Row[] = [];
}
